export const customerRoutePaths = {
    root: "customers/",
    list: "",
    add: "add",
    edit: "edit",
};
